import { Page } from '@/core/architecture'

import { OwnedItemsTemplate } from './template'
import { useViewModel } from './viewModel'

export const OwnedItems: Page = () => {
  const { state, actions } = useViewModel()

  return <OwnedItemsTemplate state={state} {...actions} />
}
